import Modal from 'tio-ui/components/modal';
import Footer from 'tio-ui/components/footer';
import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';

interface AuthRegisterEnrollConfirmNameModalSignature {
  Args: {
    show: boolean;
    onClose: () => void;
    onSubmit: () => void;
    employeeFullName: string;
    inputName: string;
  };
}

const AuthRegisterEnrollConfirmNameModal: TOC<AuthRegisterEnrollConfirmNameModalSignature> =
  <template>
    <Modal @isOpen={{@show}} @onClose={{@onClose}} class="min-h-64" @size="xl">
      <:header>{{t "enroll.confirm_name.header" name=@employeeFullName}}</:header>
      <:body>
        {{t "enroll.confirm_name.body" inputName=@inputName employeeFullName=@employeeFullName}}
      </:body>
      <:footer>
        <Footer
          @isRunning={{false}}
          @onSubmit={{@onSubmit}}
          @submitText={{t "enroll.confirm_name.register_as" name=@inputName}}
          @onCancel={{@onClose}}
          @cancelText={{t "enroll.confirm_name.yes_im" name=@employeeFullName}}
        />
      </:footer>
    </Modal>
  </template>;

export default AuthRegisterEnrollConfirmNameModal;
